module.exports = __webpack_public_path__ + "static/media/order_1.cdebd8a3.png";